/* OneMiners — Halloween promo countdown + copy (om-halloween). No deps. */
(function(){
  if (window.__omhInit) { window.__omhInit(); return; }
  var LABELS = {
    "0": ["Code vanishes in", ""],
    "1": ["The code is restless", "Something stirs in the server room…"],
    "2": ["The code is rotting", "Under 5 days left — it's starting to smell."],
    "3": ["It's alive… barely", "Under 48 hours. The undead are clawing at it."],
    "4": ["Last breath", "Final hours — the code dies at midnight ET."],
    "dead": ["", ""]
  };
  var DAY = 864e5;
  function stageFor(ms){ if (ms <= 0) return "dead"; if (ms < DAY) return "4"; if (ms < 2*DAY) return "3"; if (ms < 5*DAY) return "2"; if (ms < 10*DAY) return "1"; return "0"; }
  function pad(n){ return (n < 10 ? "0" : "") + n; }
  function track(name, params){
    try { if (window.gtag) window.gtag("event", name, params); } catch(e){}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({event: name}, params)); } catch(e){}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, params); } catch(e){}
  }
  function qsForce(){ var m = /[?&]om_spook=([^&]+)/.exec(location.search); return m ? decodeURIComponent(m[1]) : ""; }

  function init(root){
    if (root.__omh) return; root.__omh = true;
    var start = Date.parse(root.dataset.start), end = Date.parse(root.dataset.end);
    var force = qsForce() || root.dataset.force || "auto";
    var hideOutside = root.dataset.hideOutside === "true";
    var nums = {}; root.querySelectorAll("[data-omh-n]").forEach(function(n){ nums[n.dataset.omhN] = n; });
    var lbl = root.querySelector("[data-omh-lbl]"), msg = root.querySelector("[data-omh-msg]");
    var code = root.dataset.code;
    var I = {}; try { I = JSON.parse(root.dataset.i18n || "{}"); } catch(e){}
    var LB = { "0": [I.vanishes || LABELS["0"][0], ""], "1": [I.s1_l || LABELS["1"][0], I.s1_m || LABELS["1"][1]], "2": [I.s2_l || LABELS["2"][0], I.s2_m || LABELS["2"][1]], "3": [I.s3_l || LABELS["3"][0], I.s3_m || LABELS["3"][1]], "4": [I.s4_l || LABELS["4"][0], I.s4_m || LABELS["4"][1]], "dead": ["", ""] };
    var FAKE = { "0": 20*DAY+5*36e5, "1": 7*DAY+3*36e5+1234e3, "2": 3*DAY+14*36e5+2e6, "3": DAY+6*36e5+9e5, "4": 3*36e5+17*6e4+12e3, "dead": 0 };
    var fakeEnd = force !== "auto" && FAKE.hasOwnProperty(force) ? Date.now() + FAKE[force] : null;

    var last = null;
    function tick(){
      var now = Date.now();
      if (!fakeEnd && hideOutside && (now < start || now > end)) { root.hidden = true; return; }
      root.hidden = false;
      var ms = Math.max(0, (fakeEnd || end) - now);
      if (force === "dead") ms = 0;
      var s = Math.floor(ms/1000);
      if (nums.d) nums.d.textContent = pad(Math.floor(s/86400));
      if (nums.h) nums.h.textContent = pad(Math.floor(s%86400/3600));
      if (nums.m) nums.m.textContent = pad(Math.floor(s%3600/60));
      if (nums.s) nums.s.textContent = pad(s%60);
      var st = stageFor(ms);
      if (st !== last) {
        root.dataset.stage = st; last = st;
        if (lbl) lbl.textContent = LB[st][0];
        if (msg) msg.textContent = LB[st][1];
      }
      if (st === "dead") return;
      setTimeout(tick, 1000 - (now % 1000) + 5);
    }
    tick();

    carousel(root);

    var pb = root.querySelector("[data-omh-pause]");
    function setPaused(p, save){
      root.classList.toggle("is-paused", p);
      if (pb) { pb.setAttribute("aria-pressed", p ? "true" : "false"); pb.setAttribute("aria-label", p ? (I.play || "Play animation") : (I.pause || "Pause animation")); }
      if (save) { try { localStorage.setItem("omh-paused", p ? "1" : "0"); } catch(e){} }
      if (root.__omhPlay) root.__omhPlay();
    }
    try { if (localStorage.getItem("omh-paused") === "1") setPaused(true); } catch(e){}
    if (pb) pb.addEventListener("click", function(){
      var p = !root.classList.contains("is-paused"); setPaused(p, true);
      track("promo_animation_toggle", { promo_placement: root.id, paused: p });
    });

    var btn = root.querySelector("[data-omh-copy]");
    if (btn) btn.addEventListener("click", function(){
      var label = btn.querySelector("span");
      function done(){ btn.classList.add("is-done"); label.textContent = I.copied || "Copied!"; setTimeout(function(){ btn.classList.remove("is-done"); label.textContent = I.copy || "Copy"; }, 2200); }
      function fallback(){ var r = document.createRange(); r.selectNodeContents(root.querySelector("[data-omh-code]")); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); try { document.execCommand("copy"); } catch(e){} done(); }
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback); else fallback();
      track("promo_code_copy", { promo_code: code, promo_placement: root.id, promo_stage: root.dataset.stage });
    });
    root.querySelectorAll("[data-omh-cta]").forEach(function(a){
      a.addEventListener("click", function(){ track("promo_cta_click", { promo_code: code, promo_placement: root.id, cta: a.dataset.omhCta }); });
    });
  }
  /* 3D carousel: figures glide on a ring with continuous, eased speed (slows as each one passes the front,
     never stops) and levitate independently; coins orbit on a tilted ellipse. Speed follows the spook stage
     and blends smoothly between stages. Paused off-screen / hidden tab. Reduced motion = one static frame. */
  var SPEED = { "0": .2, "1": .25, "2": .33, "3": .45, "4": .75, "dead": 0 };   // figures per second
  function carousel(root){
    var stage = root.querySelector("[data-omh-stage]"); if (!stage) return;
    var figs = [].slice.call(stage.querySelectorAll(".omh__fig"));
    var coins = [].slice.call(stage.querySelectorAll(".omh__coin"));
    var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    var N = figs.length, pos = 0, v = SPEED["0"], coinT = 0, clock = 0, lastT = 0, visible = true, raf = 0;
    var shadows = figs.map(function(f){ var s = document.createElement("i"); s.className = "omh__shd"; stage.insertBefore(s, f); return s; });
    var seeds = coins.map(function(c, j){ return { a: j / coins.length * Math.PI * 2, sp: .3 + (j % 3) * .09, r: .9 + (j % 4) * .06, y: ((j % 5) - 2) * 6, b: j * 1.3 }; });
    var W = 0, H = 0;
    function measure(){ W = stage.clientWidth; H = stage.clientHeight; }
    function render(){
      var R = W * .42, TAU = Math.PI * 2;
      figs.forEach(function(f, i){
        var a = (i - pos) / N * TAU, x = Math.sin(a) * R, z = (Math.cos(a) + 1) / 2;
        var sc = .38 + .62 * Math.pow(z, 1.8);
        var lift = (Math.sin(clock * .95 + i * 1.9) * .5 + .5);            // 0..1 levitation
        var y = (1 - z) * -16 - lift * 28 * (.45 + .55 * sc) - 8;
        var tilt = Math.sin(clock * .7 + i * 2.3) * 4.5;
        f.style.transform = "translate3d(" + x.toFixed(2) + "px," + y.toFixed(2) + "px,0) rotate(" + tilt.toFixed(2) + "deg) scale(" + sc.toFixed(4) + ")";
        f.style.opacity = (.28 + .72 * z).toFixed(3);
        f.style.zIndex = Math.round(z * 20) + 5;
        var sh = shadows[i];
        sh.style.transform = "translate3d(" + x.toFixed(2) + "px," + ((1 - z) * -10).toFixed(2) + "px,0) scale(" + (sc * (1.05 - lift * .35)).toFixed(4) + ")";
        sh.style.opacity = ((.25 + .75 * z) * (.75 - lift * .45)).toFixed(3);
        sh.style.zIndex = Math.round(z * 20) + 4;
      });
      coins.forEach(function(c, j){
        var s = seeds[j], a = s.a + coinT * s.sp, d = (Math.sin(a) + 1) / 2;
        var x = Math.cos(a) * W * .5 * s.r, y = Math.sin(a) * H * .26 + s.y - Math.cos(a) * H * .1 + Math.sin(clock * 1.6 + s.b) * 5;
        c.style.transform = "translate3d(" + x.toFixed(2) + "px," + y.toFixed(2) + "px,0) scale(" + (.55 + .55 * d).toFixed(4) + ") rotateY(" + (Math.sin(a * 2) * 40).toFixed(1) + "deg)";
        c.style.opacity = (.35 + .65 * d).toFixed(3);
        c.style.zIndex = d > .5 ? 40 : 1;
      });
    }
    function frame(t){
      raf = 0;
      var dt = lastT ? Math.min(.05, (t - lastT) / 1000) : 0; lastT = t;
      var target = SPEED.hasOwnProperty(root.dataset.stage) ? SPEED[root.dataset.stage] : SPEED["0"];
      v += (target - v) * Math.min(1, dt * 1.5);                             // blend speed between stages
      var ease = 1 - .55 * Math.cos(pos * Math.PI * 2);                      // linger at the front, glide between
      pos += v * ease * dt;
      coinT += dt * (.35 + v * 2.2);
      clock += dt * (v > .01 ? 1 : .25);
      render();
      if (visible && !reduce && !root.classList.contains("is-paused") && (v > .002 || target > 0)) raf = requestAnimationFrame(frame);
    }
    function play(){ if (!raf && visible && !reduce && !root.classList.contains("is-paused")) { lastT = 0; raf = requestAnimationFrame(frame); } }
    measure(); render();
    root.__omhPlay = play;
    window.addEventListener("resize", function(){ measure(); if (reduce || !raf) render(); });
    if (reduce) return;
    if ("IntersectionObserver" in window) new IntersectionObserver(function(e){ visible = e[0].isIntersecting && !document.hidden; play(); }).observe(stage);
    document.addEventListener("visibilitychange", function(){ visible = !document.hidden; play(); });
    play();
    new MutationObserver(play).observe(root, { attributes: true, attributeFilter: ["data-stage"] });
  }

  window.__omhInit = function(){ document.querySelectorAll("[data-omh]").forEach(init); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", window.__omhInit); else window.__omhInit();
  document.addEventListener("shopify:section:load", window.__omhInit);
})();